import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo13 } from "../../../routes/Module13";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo13/Unidad2Actividad5.mp3";

const Actividad7 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "ecológico" },
    ans2: { value: "", valid: "", correctValue: "preservar" },
    ans3: { value: "", valid: "", correctValue: "recurso" },
    ans4: { value: "", valid: "", correctValue: "reforestado" },
    ans5: { value: "", valid: "", correctValue: "extracción" },
  });
  const infoUnidad = modulo13.content[1];
  const infoAct = modulo13.content[1].activities[5];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };
  const pages = {
    titleNext: `${modulo13.content[1].name}: ${modulo13.content[1].activities[6].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[1].path}/${modulo13.content[1].activities[6].path}`,
    titlePrev: `${modulo13.content[1].name}: ${modulo13.content[1].activities[4].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[1].path}/${modulo13.content[1].activities[4].path}`,
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"].toUpperCase() ===
          answers[key]["value"].toUpperCase()
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };
  const handleAnswers = (event, name) => {
    event.preventDefault();
    setAnswers({
      ...answers,
      [name]: { ...answers[name], value: event.target.value },
    });
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo13.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul>
        <li>Completa las siguientes ideas con estas palabras:</li>
      </ul>

      <Card>
        <div className="d-flex justify-content-around flex-wrap">
          <div className="m-1">preservar</div>
          <div className="m-1">ecológico</div>
          <div className="m-1">reforestado</div>
          <div className="m-1">extracción</div>
          <div className="m-1">recurso</div>
        </div>
      </Card>

      <Card>
        <p className="fs-5">
          Existe un nuevo tipo de turismo interesado en apreciar y conservar el
          entorno. Se le conoce como turismo{" "}
          <input
            type="text"
            className={
              "form-control form-control-sm w-200 d-inline-block " +
              answers.ans1.valid
            }
            value={answers.ans1.value}
            onChange={(event) => handleAnswers(event, "ans1")}
          />{" "}
          .
        </p>
        <p className="fs-5">
          Todos somos responsables de{" "}
          <input
            type="text"
            className={
              "form-control form-control-sm w-200 d-inline-block " +
              answers.ans2.valid
            }
            value={answers.ans2.value}
            onChange={(event) => handleAnswers(event, "ans2")}
          />{" "}
          el medio ambiente y evitar la contaminación del entorno en que
          vivimos.
        </p>
        <p className="fs-5">
          Un{" "}
          <input
            type="text"
            className={
              "form-control form-control-sm w-200 d-inline-block " +
              answers.ans3.valid
            }
            value={answers.ans3.value}
            onChange={(event) => handleAnswers(event, "ans3")}
          />{" "}
          es aquello que obtenemos de nuestro entorno para satisfacer nuestras
          necesidades, por ejemplo, el agua, la madera y el gas.
        </p>
        <p className="fs-5">
          La comunidad de Porcón en Cajamarca ha{" "}
          <input
            type="text"
            className={
              "form-control form-control-sm w-200 d-inline-block " +
              answers.ans4.valid
            }
            value={answers.ans4.value}
            onChange={(event) => handleAnswers(event, "ans4")}
          />{" "}
          sus terrenos a través de la plantación de árboles de pino.
        </p>
        <p className="fs-5">
          La{" "}
          <input
            type="text"
            className={
              "form-control form-control-sm w-200 d-inline-block " +
              answers.ans5.valid
            }
            value={answers.ans5.value}
            onChange={(event) => handleAnswers(event, "ans5")}
          />{" "}
          de recursos naturales, como los peces y la madera, debe hacerse
          siempre pensando en su conservación.
        </p>
      </Card>
      <div className="row my-4">
        <div className="col-12">
          <button
            className={`btn float-end btn-${modulo13.color}`}
            onClick={validateAnswers}
          >
            Enviar respuestas
          </button>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea la indicación: Completa las siguientes ideas con estas palabras:
            preservar, ecológico, reforestado, recurso, extracción. Dé un tiempo
            para que trabajen individualmente. Revise sus respuestas y haga
            preguntas:
            <ul>
              <li>
                <i>
                  “¿Qué significa turismo ecológico? (Posible respuesta: Como el
                  texto lo dice, es un tipo de turismo que busca que los
                  viajeros aprecien y conserven el entorno)”.
                </i>
              </li>
              <li>
                <i>
                  “¿Qué significa preservar? (Posible respuesta: Como sinónimos
                  de la palabra preservar, tenemos, por ejemplo, las palabras
                  conservar y mantener. No preservar un recurso puede llevar a
                  que este desaparezca)”.
                </i>
              </li>
              <li>
                <i>
                  “¿Qué significa la palabra recurso? (Posible respuesta: En el
                  texto se indica que son los elementos que obtenernos de
                  nuestro entorno y que nos son útiles)”.
                </i>
              </li>
              <li>
                <i>
                  “¿Qué significa la palabra reforestado? (Posible respuesta:
                  Significa que un espacio determinado ha sido repoblado con
                  plantas o árboles. Talar los árboles sería la acción contraria
                  a reforestar una zona)”.
                </i>
              </li>
              <li>
                <i>
                  “¿Qué significa la palabra extracción? (Posible respuesta:
                  Significa tomar o sacar algo de la naturaleza para
                  utilizarlo)”.
                </i>
              </li>
              <li>
                <i>
                  “¿Qué pasaría si las personas solo se dedicaran a la
                  extracción y no a la conservación de recursos? (Posible
                  respuesta: Desaparecerían los recursos)”.
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad7;
